// Storefront badge — used on product cards, cart summary, order status, etc.
// Distinct from AntD's `Badge` (which is a notification dot) — this is a
// pill label. Variants map to semantic colours pulled from CSS variables
// so the active industry can re-skin them.
import { Tag } from 'antd';

const VARIANT_PROPS = {
  sale: { color: 'red', children: 'Sale' },
  new: { color: 'green', children: 'New' },
  soldOut: { color: 'default', children: 'Sold out' },
  featured: { color: 'gold', children: 'Featured' },
  custom: {},
};

/**
 * @param {{ variant?: 'sale'|'new'|'soldOut'|'featured'|'custom', label?: string, color?: string, icon?: any, style?: object }} props
 */
export default function Badge({ variant = 'custom', label, color, icon, style }) {
  const base = VARIANT_PROPS[variant] ?? VARIANT_PROPS.custom;
  return (
    <Tag color={color ?? base.color} icon={icon} style={style}>
      {label ?? base.children}
    </Tag>
  );
}
